import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function EmptyState({
  icon = "ri-information-line",
  title,
  description,
  actionLabel,
  actionTo,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 rounded-lg border border-dashed border-background-300 bg-background-100/60">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-background-200 text-accent-400 text-3xl mb-4">
        <i className={icon} />
      </span>
      <h3 className="font-heading text-lg font-semibold text-foreground-900">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-foreground-600 max-w-md leading-relaxed">
          {description}
        </p>
      )}
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="mt-6 inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-600 hover:bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}